// extracted by mini-css-extract-plugin
export default {"main":"ErrorPage_main__KXOLe","err":"ErrorPage_err__3CWY5","errNo":"ErrorPage_errNo__2d+5t","errEmg":"ErrorPage_errEmg__4OZWT","errText":"ErrorPage_errText__TD6lw"};